import Control, { DropdownIndicator, ClearIndicator } from "./control"
import SingleValue from "./single-value"
import { SelectContainer, ValueContainer, IndicatorsContainer } from "./containers"
import { Menu, Option } from "./menu"
import Placeholder from "./placeholder"

const components = {
  SelectContainer,
  Control,
  ValueContainer,
  Menu,
  Option,
  Placeholder,
  SingleValue,
  ClearIndicator,
  DropdownIndicator,
  IndicatorsContainer,
  IndicatorSeparator: (): null => null,
  MultiValue: (): null => null,
  MultiValueContainer: (): null => null,
  MultiValueRemove: (): null => null,
}

export default components